// DS: MO3.4
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import DeviationDumbView from '../../../DeviationViews/Dumbo';
import DetailsDumb from '../DetailsDumb';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import UserLink from '../../../User/Link/UserLink';
import s from './ShopCardDumb.scss';
export const COVER_IMG_HEIGHT = 200;
export const OWNER_AVATAR_SIZE = 24;
const ShopCardDumb = ({ className, width, coverImage, coverImageHeight = COVER_IMG_HEIGHT, title, withAuthorDetails, author, withDescriptionBlock, description, indicatorsSlot, belowCoverImageSlot, detailsRightSlot, withOwnerDetails, owner, footerSlot })=>{
    const { t } = useTranslation();
    const dumboWidth = width - parseInt(s['border-width']) * 2;
    const shop_owner_indicators = useFlag('shop_owner_indicators');
    // todo: there is an edge case where an author -buys back- a work that we
    // may want to handle here at some point
    const isNewOwner = owner && (author === null || author === void 0 ? void 0 : author.userId) && owner.userId !== author.userId;
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className),
        style: {
            width
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['indicators-slot']
    }, indicatorsSlot), /*#__PURE__*/ React.createElement("div", {
        className: s['overlay-container'],
        style: {
            width: dumboWidth,
            height: coverImageHeight
        }
    }, coverImage ? /*#__PURE__*/ React.createElement(DeviationDumbView, {
        className: s['cover-image'],
        deviation: coverImage,
        useCoverMode: true,
        width: dumboWidth,
        height: coverImageHeight
    }) : /*#__PURE__*/ React.createElement("div", {
        style: {
            width: dumboWidth,
            height: coverImageHeight
        },
        className: c(s['cover-image'], s['empty-cover-image']),
        role: "presentation"
    }), shop_owner_indicators && withOwnerDetails && isNewOwner && /*#__PURE__*/ React.createElement("div", {
        className: c(s['shop_owner_indicators'], s['owner-overlay'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['shop_owner_indicators'], s['owner-details'])
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: owner,
        size: OWNER_AVATAR_SIZE
    }), t('shop.thumb.adoptable.ownedBy'), /*#__PURE__*/ React.createElement(UserLink, {
        user: owner,
        className: s['owner-link']
    }))), !shop_owner_indicators && withOwnerDetails && owner && /*#__PURE__*/ React.createElement("div", {
        className: s['owner-overlay']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['owner-details']
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: owner,
        size: OWNER_AVATAR_SIZE
    }), t('shop.thumb.adoptable.ownedBy'), /*#__PURE__*/ React.createElement(UserLink, {
        user: owner,
        className: s['owner-link']
    })))), /*#__PURE__*/ React.createElement("div", {
        className: s['below-cover-image-slot']
    }, belowCoverImageSlot), /*#__PURE__*/ React.createElement(DetailsDumb, {
        className: s['details'],
        title: title,
        withAuthorDetails: withAuthorDetails,
        author: author,
        withDescriptionBlock: withDescriptionBlock,
        description: description,
        rightSlot: detailsRightSlot,
        withOwnerDetails: withOwnerDetails,
        owner: owner
    }), footerSlot && /*#__PURE__*/ React.createElement("div", {
        className: s['footer-slot']
    }, footerSlot));
};
ShopCardDumb.displayName = 'ShopCardDumb';
export default ShopCardDumb;

//# sourceMappingURL=ShopCardDumb.js.map